export const message = {
  updateCompanySettingsSuccess: 'Company settings successfully updated',
}